import React from "react"

import {useTheme, Paper} from "@mui/material";
import Grid from "@mui/material/Grid2"

import {orangeBackgroundColor} from "../../../constants"
import {DeliveryTypeSection} from "./DeliveryTypeSection"
import {DeadlineSection} from "./DeadlineSection"
import {ConstructionSiteSection} from "./ConstructionSiteSection"

export const DeliveryStep = () => {
    const theme = useTheme()

    return (<Paper square={true}
                   sx={{
                       background: orangeBackgroundColor, padding: theme.spacing(6)
                   }}>
        <Grid container spacing={6}>
            <Grid container spacing={6} size={12}>
                <Grid size={6}>
                    <DeadlineSection/>
                </Grid>
                <Grid size={6}>
                    <DeliveryTypeSection/>
                </Grid>
            </Grid>
            <Grid>
                <ConstructionSiteSection/>
            </Grid>
        </Grid>
    </Paper>)
}
